import { SearchWidgetContext } from '@/context/SearchWidgetContextProvider';
import { useContext } from 'react';

export const useSearchWidget = () => {
  const context = useContext(SearchWidgetContext);

  if (context === undefined) {
    throw new Error(
      'useSearchWidget must be used within a SearchWidgetProvider'
    );
  }

  return context;
};
